/* tslint:disable */
/* eslint-disable */
/**
 * ISO Backend Modules API
 * ISO API for the IBE.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ApiConfigurationDataType;
(function (ApiConfigurationDataType) {
    ApiConfigurationDataType["POSTALCODE"] = "POSTAL_CODE";
    ApiConfigurationDataType["COUNTRIES"] = "COUNTRIES";
    ApiConfigurationDataType["NATIONALITIES"] = "NATIONALITIES";
    ApiConfigurationDataType["SALUTATIONS"] = "SALUTATIONS";
    ApiConfigurationDataType["BUSINESSPARTNERSUBTYPE"] = "BUSINESSPARTNER_SUBTYPE";
    ApiConfigurationDataType["BUSINESSPARTNERORIGIN"] = "BUSINESSPARTNER_ORIGIN";
    ApiConfigurationDataType["CONTACTROLE"] = "CONTACT_ROLE";
    ApiConfigurationDataType["VEHICLECATEGORY"] = "VEHICLE_CATEGORY";
    ApiConfigurationDataType["LANGUAGES"] = "LANGUAGES";
    ApiConfigurationDataType["CURRENCIES"] = "CURRENCIES";
    ApiConfigurationDataType["UNITTYPE"] = "UNIT_TYPE";
    ApiConfigurationDataType["SERVICEGROUP"] = "SERVICE_GROUP";
    ApiConfigurationDataType["COUNTRYREGIONS"] = "COUNTRY_REGIONS";
    ApiConfigurationDataType["CABINCLASS"] = "CABIN_CLASS";
    ApiConfigurationDataType["TARIFF"] = "TARIFF";
    ApiConfigurationDataType["PACKAGEDEFINITION"] = "PACKAGE_DEFINITION";
    ApiConfigurationDataType["TAX"] = "TAX";
    ApiConfigurationDataType["GENDER"] = "GENDER";
    ApiConfigurationDataType["TITLE"] = "TITLE";
    ApiConfigurationDataType["OPTIONTYPE"] = "OPTION_TYPE";
    ApiConfigurationDataType["SERVICECHARACTERISTICS"] = "SERVICE_CHARACTERISTICS";
})(ApiConfigurationDataType || (ApiConfigurationDataType = {}));
function ApiConfigurationDataTypeFromJSON(json) {
    return ApiConfigurationDataTypeFromJSONTyped(json);
}
function ApiConfigurationDataTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ApiConfigurationDataTypeToJSON(value) {
    return value;
}

export { ApiConfigurationDataType, ApiConfigurationDataTypeFromJSON, ApiConfigurationDataTypeFromJSONTyped, ApiConfigurationDataTypeToJSON };
//# sourceMappingURL=ApiConfigurationDataType.js.map
